export const destinations = [
    {
        id: '',
        name:'',
        surName:'',
        phoneNumber:'',
        cpf:'',
        cep:'',
        address:'',
        addressNumber:'',
        addressInfo:'',
        neighbourhood:'',
        city:'',
        uf:''
    },
]